import { FileDataDisplay } from "#src/components/DataDisplay/FileDataDisplay";
import {
  Icon,
  getIconVariantFromFileExtension,
} from "@validereinc/common-components";
import { type CommentFileSchemaType } from "@validereinc/domain";
import { getFileExtensionFromFilename } from "@validereinc/utilities";
import React, { type CSSProperties } from "react";
import classNames from "classnames/bind";
import styles from "./CommentFilesDataDisplay.module.css";

const cx = classNames.bind(styles);

export type CommentFilesDataDisplayType = {
  /** The files to render as FileDataDisplays. */
  files: CommentFileSchemaType[];
  /** The class name to apply to the component. */
  className?: string;
  /** The style to apply to the component */
  style?: CSSProperties;
};

export const CommentFilesDataDisplay = ({
  files,
  className,
  style,
}: CommentFilesDataDisplayType) => {
  return (
    <div
      className={cx("container", className)}
      style={style}
    >
      {files.map((file) => (
        <FileDataDisplay
          key={file.file_id}
          className={cx("file")}
          fileId={file.file_id}
          fileName={file.file_name}
          slotLeft={
            <Icon
              variant={getIconVariantFromFileExtension(
                getFileExtensionFromFilename(file.file_name)
              )}
              size={22}
              style={{ flexShrink: 0 }}
            />
          }
          prefetch={false}
          alignment="left"
          shouldTruncateFilename
        />
      ))}
    </div>
  );
};
